import { useOrganizationBranding } from '../../../../components/dashboard/use-organization-branding';
import { isPresentString } from './utils';

export function useClientPortalFirmBranding() {
  const { branding, loading } = useOrganizationBranding();

  return {
    firmName: isPresentString(branding?.displayName) ? branding.displayName : null,
    firmLogoUrl: isPresentString(branding?.logoUrl) ? branding.logoUrl : null,
    loading,
  };
}
